import BaseRoute from "../../../../../../lib/itn-ui-kit/route/base-route";

import Template from "./template";

export default class ClientDetailGeneralRoute extends BaseRoute {
  id = "client-detail-case-general";
  ignoreQueryKeys = ["rvClientDetail"];
  revalidateOnParams = [];
  revalidateOnQueryKeys = [];
  revalidateOnQueryAnyChange = false;

  element = (<Template />);

  async loader() {
    return {};
  }

  shouldRevalidate() {
    return false;
  }
}
